/*
  Minimalistischer Scroll-Reveal: Elemente mit Klasse "ss-reveal" faden/slide-n beim
  Reinscrollen sanft ein. Einmal pro Seite einbinden (idempotent, mehrfaches Einbinden
  durch mehrere Sections ist unproblematisch). Respektiert prefers-reduced-motion.
*/
(function () {
  if (window.__ssScrollRevealInit) return;
  window.__ssScrollRevealInit = true;

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(entries, observer) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }

  function init() {
    var targets = document.querySelectorAll('.ss-reveal:not(.is-visible)');
    if (!targets.length) return;

    if (prefersReduced || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    // Schwelle 0 = greift schon beim ersten Pixel (wichtig bei großen Bildern,
    // sonst leere Platzhalter). Auslöser genau an der unteren Sichtkante, damit
    // man die Animation beim Reinscrollen auch wirklich SIEHT.
    var observer = new IntersectionObserver(reveal, {
      threshold: 0,
      rootMargin: '0px 0px 0px 0px'
    });

    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme-Editor: neu geladene/hinzugefügte Sections erneut prüfen
  document.addEventListener('shopify:section:load', init);
})();